<template>
  <div class="container college">
    <div class="header card">
      <el-breadcrumb class="breadcrumb"
                     separator="/">
        <el-breadcrumb-item>调剂系统</el-breadcrumb-item>
        <el-breadcrumb-item>机构用户</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">机构用户</h2>
        </div>
        <div class="right">
          <el-button class="button"
                     type="primary"
                     @click="handleUserCreate">新建</el-button>

        </div>
      </div>
    </div>
    <div class="filters card">
      <el-form class="search-wrap"
               ref="searchForm"
               :inline="true"
               :model="query">

        <el-form-item label="用户昵称"
                      prop="user">
          <el-input v-model.trim="query.user_keyword"
                    placeholder="输入用户昵称/姓名/手机号"
                    clearable
                    @input="searchSetTimeout()"></el-input>
        </el-form-item>
      </el-form>
      <!--       <div class="divider"></div>
      <div class="action-wrap">
        <el-button type="primary" @click="handleSearch">搜索</el-button>
        <el-button @click="handleFormReset('searchForm')">重置</el-button>
        <el-button icon="el-icon-download" @click="handleExport"
          >导出</el-button
        >
      </div> -->
    </div>
    <div class="results card">
      <div class="values-header">
        <p class="title">查找结果</p>
      </div>
      <div class="values">
        <el-table class="table"
                  :data="results"
                  border
                  style="width: 100%">
          <el-table-column prop="id"
                           label="ID"
                           width="80"
                           align="center">
          </el-table-column>
          <el-table-column label="用户"
                           min-width="160"
                           align="center">
            <template slot-scope="scope">
              <span>{{scope.row.user_nickname }}/{{scope.row.user_realname }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="user_mobile"
                           label="手机号"
                           min-width="160"
                           align="center">
          </el-table-column>
          <el-table-column prop="apply_exist_modify_count"
                           label="报考信息修改次数"
                           min-width="160"
                           align="center">
            <template slot-scope="scope">
              <span>{{ formateCount(scope.row.apply_exist_modify_count)}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="score_exist_modify_count"
                           label="成绩信息修改次数"
                           min-width="160"
                           align="center">
            <template slot-scope="scope">
              <span>{{ formateCount(scope.row.score_exist_modify_count)}}</span>
            </template>
          </el-table-column>
          <el-table-column label="开通时间"
                           width="160"
                           align="center">
            <template slot-scope="scope">
              <span>{{
                $moment(scope.row.open_unlimit_time).format("YYYY-MM-DD HH:mm")
              }}</span>
            </template>
          </el-table-column>

        </el-table>
      </div>
      <div class="footer">
        <el-pagination background
                       layout="total, prev, pager, next, sizes, jumper"
                       :current-page="Number(query.pageIndex)"
                       :page-sizes="[10, 20, 50, 100, 500]"
                       :page-size="Number(query.pageSize)"
                       :total="Number(pageTotal)"
                       @size-change="handleSizeChange"
                       @current-change="handlePageChange"></el-pagination>
      </div>
    </div>
    <MemberChoose :visible="userChooseDialog"
                  @close="userChooseDialog = false"
                  @submit="saveMember"></MemberChoose>
  </div>
</template>

<script>
import { getUnlimitUserlist, modifyCountUnlimit } from '@/api/adjust'
import MemberChoose from '@/components/dialog/member/MemberChoose'

let Timer = null // 定时器
let TimerTime = 1000 // 定时器 等待时长

export default {
  components: {
    MemberChoose,
  },
  data() {
    return {
      query: {
        user_keyword: '',
      },
      admin_referrer: '',
      createDatetime: '',
      pageTotal: 10,

      results: [],
      userChooseDialog: false,
    }
  },
  watch: {
    // 时间数据监听
    createDatetime(value) {
      if (value) {
        this.query.startTime = this.$moment(value[0]).valueOf()
        this.query.endTime = this.$moment(value[1]).valueOf()
      } else {
        this.query.startTime = ''
        this.query.endTime = ''
      }
    },
  },
  created() {
    // this.parseQuery()
    this.fetchUnlimitUserList()
  },
  methods: {
    formateCount(count) {
      let realcount = count + 999999
      return realcount + '次'
    },
    fetchUnlimitUserList(isReset = false) {
      if (isReset) {
        this.$set(this.query, 'pageIndex', 1)
      }
      const params = Object.assign({}, this.query)

      getUnlimitUserlist(params).then((res) => {
        this.results = res.list || []
        this.pageTotal = res.count
        console.log('res:', this.results)
      })
    },
    searchSetTimeout() {
      clearTimeout(Timer)
      Timer = setTimeout(() => {
        this.fetchUnlimitUserList(true)
      }, TimerTime)
    },

    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.fetchUnlimitUserList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.fetchUnlimitUserList()
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, 'pageIndex', 1)
      this.fetchUnlimitUserList()
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields()
      // 手动处理
      this.createDatetime = null
      this.fetchUnlimitUserList()
    },
    // 订单状态渲染

    // 订单创建
    handleUserCreate() {
      this.userChooseDialog = true
    },
    saveMember({ users }) {
      if (users && users.length > 5) {
        this.$message.error('最多只能开通100个用户')
        return
      }

      if (users && users.length > 0) {
        const idArray = users.map((user) => user.id)
        console.log('users', idArray)
        modifyCountUnlimit({ arr_uid: idArray }).then((res) => {
          this.$message.success('开通成功')
          this.fetchUnlimitUserList()
        })
      }
    },
  },
}
</script>

<style scoped lang="less">
.college {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
      overflow-y: visible;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
    }
    .avatar {
      display: block;
      width: 68px;
      height: 68px;
      object-fit: cover;
      margin: 0 auto;
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
}
</style>
